import React from "react";
import img404 from "@/src/assets/img404.png";
import { Link } from "react-router-dom";
import "./style.scss";

const Default404 = () => {
  return (
    <div className="page-404 container">
      <img src={img404} alt="img404" />
      <p>
        <span>"Упс! </span>Страница не найдена"
      </p>
      <Link className="page-404-link" to={"/"}>
        Вернутся на главную →
      </Link>
    </div>
  );
};

export default Default404;
